import { environment } from '@env/environment';
import SuperTokens from 'supertokens-web-js';
import EmailVerification from 'supertokens-web-js/recipe/emailverification';
import Session from 'supertokens-web-js/recipe/session';

export function initSuperTokensWebJS() {
  SuperTokens.init({
    appInfo: {
      appName: 'Thkee Admin',
      apiDomain: environment.serverUrl,
    },
    recipeList: [Session.init({ sessionTokenFrontendDomain: environment.thkCookieDomain }), EmailVerification.init()],
  });
}
